import { UserAuth } from "../../context/authContext";

const ProtectedRoute = ({ children }) => {
  const { user, isAuthLoading } = UserAuth();

  // Show nothing while auth is loading to prevent flicker
  if (isAuthLoading) {
    return null;
  }

  if (!user) {
    window.location.href = "/login";
  } else {
    return children;
  }
};

export default ProtectedRoute;
